import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function DreamSection() {
  return <section className="py-24 px-6 bg-blush/20 text-ink relative overflow-hidden" data-id="element-62">
      {/* Subtle glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-glow/50 rounded-full blur-[120px] pointer-events-none" data-id="element-63" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center justify-center w-16 h-16 rounded-full border border-gold/30 mb-8 bg-white/50 backdrop-blur-sm" data-id="element-65">
          <Sparkles className="text-gold" size={24} data-id="element-66" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-4xl md:text-6xl font-serif text-ink-dark mb-12" data-id="element-67">
          Imagina esto:
        </motion.h2>

        <div className="space-y-8 font-serif text-2xl md:text-3xl leading-relaxed max-w-3xl mx-auto" data-id="element-68">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-69">
            Abres los ojos por la mañana. No hay máscara por aplicar. No hay
            espejo de emergencia.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-gold-dark font-medium" data-id="element-70">
            Solo tú — con una mirada limpia, definida, irresistible.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} data-id="element-71">
            Llegas al trabajo. A una cita. A recoger a tus hijos. Y la gente te
            mira diferente. No saben por qué. Pero tú sí.
            <br data-id="element-72" />
            <br data-id="element-73" />
            <span className="font-medium text-gold-dark" data-id="element-74">
              Pestañas listas para impactar, precios listos para sorprenderte.
            </span>
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="mt-16 pt-12 border-t border-gold/20" data-id="element-75">
          <p className="font-sans text-lg uppercase tracking-widest text-ink-light" data-id="element-76">
            Eso es lo que hace una artista con 8 años de experiencia. Pestañas
            listas para impactar, precios listos para sorprenderte.
          </p>
          <p className="font-serif text-3xl mt-4 text-ink-dark" data-id="element-77">
            No pone pestañas.{' '}
            <span className="text-gold-dark italic" data-id="element-78">Diseña tu mirada.</span>
          </p>
        </motion.div>

        {/* Frases 3 */}
        <div className="mt-24 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-79">
          {['Cada sesión de cuidado de pestañas es un acto de amor propio y dedicación.', 'Si mis ojos hablaran... dirían: Gracias por estas pestañas', 'Como lashista, mi misión es que tu belleza natural destaque con estilo propio.', 'No se trata solo de belleza, se trata de cómo tus pestañas pueden reflejar tu fuerza y tu estilo.', 'La paciencia, la precisión y la creatividad hacen de cada lashista una artista única.'].map((frase, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className={`p-8 bg-white/60 backdrop-blur-sm border border-gold/20 rounded-sm flex items-center justify-center ${idx === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-80">
              <p className="font-serif text-xl text-ink-dark text-center italic" data-id="element-81">
                "{frase}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}